import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useToast } from '../../../contexts/ToastContext';
import { fetchServices } from '../../../api/serviceApi';
import ServiceCard from '../../../components/ServiceCard';
// Removed: import SkeletonLoader from '../../../components/SkeletonLoader'; // Removed unused import

function ServicesSection() {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const { addToast } = useToast();

  useEffect(() => {
    const fetchServicesData = async () => {
      try {
        setLoading(true);
        // Fetch a limited number of services for the home page
        const data = await fetchServices({ limit: 3, paginate: false });

        if (data.success) {
          const formattedServices = data.data.map(service => ({
            id: service.id,
            title: service.name,
            description: service.excerpt,
            slug: service.slug,
            image: service.image,
          }));
          setServices(formattedServices);
        } else {
          addToast('error', data.message || 'Failed to fetch services.');
        }
      } catch (e) {
        console.error("Error fetching services for home page:", e);
        addToast('error', 'Failed to load services. Please try again later.');
      } finally {
        setLoading(false);
      }
    };

    fetchServicesData();
  }, [addToast]);

  // If no services and not loading, return null to hide the section
  if (!loading && services.length === 0) {
    return null;
  }

  return (
    <section className="py-16 bg-bg-dark text-text-gray border-y border-border-subtle">
      <div className="container mx-auto px-4">
        <h2 className="text-4xl font-bold text-center text-text-white relative after:content-[''] after:absolute after:bottom-0 after:left-1/2 after:-translate-x-1/2 after:w-20 after:h-1 after:bg-accent-red after:rounded-sm after:bottom-[-15px] mb-12">
          My Services
        </h2>

        {loading ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {Array.from({ length: 3 }).map((_, index) => (
              <div key={index} className="bg-bg-light p-8 rounded-lg shadow-md border border-border-subtle animate-pulse">
                <div className="h-6 bg-gray-700 rounded w-3/4 mb-4"></div>
                <div className="h-4 bg-gray-700 rounded w-full mb-2"></div>
                <div className="h-4 bg-gray-700 rounded w-5/6 mb-4"></div>
                <div className="h-4 bg-gray-700 rounded w-1/2 mb-1"></div>
                <div className="h-4 bg-gray-700 rounded w-2/3"></div>
                <div className="h-4 bg-gray-700 rounded w-1/3"></div>
              </div>
            ))}
          </div>
        ) : (
          <>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {services.map(service => (
                <ServiceCard key={service.id} service={service} />
              ))}
            </div>
            <div className="text-center mt-12">
              <Link to="/services" className="bg-accent-red text-text-white rounded-full px-8 py-4 font-bold transition-all duration-300 hover:bg-red-700 hover:-translate-y-0.5">
                View All Services
              </Link>
            </div>
          </>
        )}
      </div>
    </section>
  );
}

export default ServicesSection;